import fetchMedia from 'utils/fetchMedia';

const getFile = async file => {
  const response = await fetchMedia(file, {
    method: 'GET',
  });

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  }

  return await response.arrayBuffer();
};

export default getFile;
